import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCanadaFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M45.9996 4.62879C41.2109 1.60493 35.6634 0 29.9999 0C24.3364 0 18.7888 1.60493 14.0001 4.62879V55.3723C18.7892 58.3951 24.3366 59.9995 29.9999 59.9995C35.6631 59.9995 41.2105 58.3951 45.9996 55.3723V4.62879Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.9995 4.62891V55.3724C50.2867 52.6707 53.8193 48.9266 56.2676 44.4898C58.7159 40.053 59.9999 35.0681 59.9999 30.0007C59.9999 24.9332 58.7159 19.9484 56.2676 15.5116C53.8193 11.0748 50.2867 7.33069 45.9995 4.62891V4.62891Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0001 4.62891C9.71305 7.33074 6.1805 11.0748 3.73227 15.5116C1.28405 19.9484 0 24.9332 0 30.0007C0 35.0681 1.28405 40.0529 3.73227 44.4897C6.1805 48.9265 9.71305 52.6706 14.0001 55.3724V4.62891Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.4214 29.4298C41.2637 29.3635 41.1354 29.2422 41.0605 29.0884C40.9855 28.9346 40.969 28.7588 41.0141 28.5938L42.0446 24.9658L38.5701 25.6878C38.4503 25.7039 38.1181 25.6778 37.9461 24.998L37.6392 23.763L35.2305 26.5269C35.2305 26.5269 33.6702 28.2178 34.1608 25.6356L35.2074 20.1186L33.2713 21.079C33.1617 21.1217 32.7801 21.1769 32.274 20.2208L30.5087 16.875L28.7412 20.2196C28.2354 21.1758 27.8547 21.1209 27.7443 21.0779L25.81 20.1178L26.8555 25.6345C27.3444 28.2167 25.7859 26.5258 25.7859 26.5258L23.376 23.7619L23.0692 24.9969C22.8971 25.6778 22.5672 25.7028 22.4454 25.6867L18.9715 24.9647L20.0012 28.5926C20.0463 28.7576 20.0299 28.9333 19.9552 29.0871C19.8805 29.241 19.7525 29.3624 19.5949 29.4289L18.5081 29.9059C18.5081 29.9059 22.4934 33.0877 23.7995 34.1729C24.0542 34.3829 24.6693 34.9975 24.4573 35.6579L23.9912 37.1008L29.4452 36.2725C29.7257 36.2498 30.3231 36.2975 30.2851 37.1807L30.0312 42.8747H30.9843L30.7302 37.1815C30.6924 36.2986 31.2931 36.2498 31.5703 36.2736L37.0241 37.1016L36.5582 35.6588C36.3462 34.9987 36.9611 34.3838 37.2166 34.174C38.5232 33.0877 42.5086 29.9059 42.5086 29.9059L41.4214 29.4298Z",
			fill: "#ED4C5C"
		})
	]
});
export default SvgCanadaFlag;
